import axiosInstance from "@/api/axiosInstance";
import type { MembershipSku } from "@/modules/hub/features/MembershipSkuManagement/schemas/membershipSkuSchema";
import type { FetchMembershipSkusResponse } from "./types";

/**
 * Fetch all membership SKUs
 * @param tenant - Optional tenant ID to filter SKUs
 */
export const fetchMembershipSkus = async (
  tenant?: string,
): Promise<MembershipSku[]> => {
  const params = tenant ? { tenant } : {};
  const response = await axiosInstance.get<FetchMembershipSkusResponse>(
    "/api/private/membership-skus",
    { params },
  );
  return response.data.data || [];
};
